export default __webpack_public_path__ + "static/media/Whoweare-img-1.32f670a8.png";